// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"761":"c74479d6","899":"67bf11ed"}[chunkId] + ".chunk.js";
};